<!-- Header -->
<app-nav-header [collapsed]="store.effectiveCollapsed()" [logoSrc]="logoSrc()" (mouseenter)="onMouseEnter()" />

<!-- Body -->
<div class="flex flex-col gap-2 flex-1 overflow-y-auto px-2 py-2 scrollbar-dark" (mouseenter)="onMouseEnter()">
  <nav [attr.aria-label]="'sidebar.navigation' | transloco" class="flex flex-col gap-1">
    @for (entry of visibleNavigation(); track entry.id) {
      @if (isRootItem(entry)) {
        <!-- Root item: render as direct navigation link -->
        <app-nav-item
          [item]="entry"
          [currentUrl]="currentUrl()"
          [collapsed]="store.effectiveCollapsed()"
        />
      } @else {
        <!-- Root group/section: render with expansion -->
        <app-nav-section
          [section]="entry"
          [collapsed]="store.effectiveCollapsed()"
          [expanded]="store.isSectionExpanded(entry.id)"
          [currentUrl]="currentUrl()"
          (toggleSection)="store.toggleSection(entry.id)"
        />
      }
    } @empty {
      <!-- Empty navigation: render nothing in body -->
    }
  </nav>

  <!-- Dev tools (env- + rights-gated) — pinned to the bottom with a clear separator -->
  @if (bottomNavigation().length) {
    <nav
      [attr.aria-label]="'sidebar.devTools' | transloco"
      class="mt-auto flex flex-col gap-1 border-t border-border-primary pt-2"
    >
      @for (item of bottomNavigation(); track item.id) {
        <app-nav-dev-item
          [item]="item"
          [currentUrl]="currentUrl()"
          [collapsed]="store.effectiveCollapsed()"
        />
      }
    </nav>
  }
</div>

<!-- Footer -->
<div data-testid="sidebar-footer" class="flex flex-col shrink-0 gap-2 px-2 py-2 border-t border-border-primary">
  <!-- ⚠️ DIVERGENCE LOCALE BackStage — voir ../PROVENANCE.md.
       La source monte ici <app-tenant-switcher> et <app-user-menu>, deux
       composants de core/auth adosses a l'OIDC multi-tenant du Manager.
       BackStage s'authentifie via MSAL et n'a qu'un locataire : le bloc devient
       une projection, l'application y place son propre pied de menu. -->
  <ng-content select="[sidebar-account]" />

  <!-- Theme and Collapse Controls -->
  <div [class]="footerControlsClasses()">
    <!-- DIVERGENCE LOCALE BackStage : bascule optionnelle. BackStage est
         monolingue, il masque ce bouton. Par defaut visible = rendu de la source. -->
    @if (showLanguageToggle()) {
    <!-- Language Toggle -->
    <button
      type="button"
      class="nav-section-trigger cursor-pointer"
      [attr.aria-label]="'sidebar.toggleLanguage' | transloco"
      (click)="language.toggle()"
    >
      @if (!store.effectiveCollapsed()) {
        <span class="truncate" appEllipsisTooltip [contrasted]="true">{{ language.label() }}</span>
      } @else {
        <span class="text-xs">{{ language.language() === 'fr' ? 'FR' : 'EN' }}</span>
      }
    </button>
    }

    <!-- DIVERGENCE LOCALE BackStage : bascule optionnelle, meme raison. -->
    @if (showThemeToggle()) {
    <!-- Theme Toggle -->
    <button
      type="button"
      class="nav-section-trigger cursor-pointer"
      [attr.aria-pressed]="theme.isDark()"
      [attr.aria-label]="'sidebar.toggleTheme' | transloco"
      (click)="theme.toggle()"
    >
      @if (!store.effectiveCollapsed()) {
        <span class="truncate" appEllipsisTooltip [contrasted]="true">{{ theme.label() }}</span>
      } @else {
        <span class="text-xs">{{ theme.isDark() ? '☀️' : '🌙' }}</span>
      }
    </button>
    }

    <!-- Collapse Toggle -->
    <button
      type="button"
      class="nav-section-trigger cursor-pointer"
      [attr.aria-expanded]="!store.collapsed()"
      [attr.aria-label]="'sidebar.toggleSidebar' | transloco"
      (click)="toggleCollapsed()"
    >
      @if (store.effectiveCollapsed()) {
        <app-icon name="panel-left-open" />
      } @else {
        <app-icon name="panel-left-close" />
      }
    </button>
  </div>
</div>
